/* eslint-disable import/prefer-default-export */
export const TOTAL_ACCOUNTS_FIELD_NAME = 'Authorized Accounts';
